export const isValidNumber = (value: string) => {
  if (value === '')
    return false;

  // only numeric values are allowed after removing thousand separator and decimal point
  return /^\d+$/.test(value.replaceAll(',', '').replaceAll('.', ''));
}